import "./WhyUs.css";
import workshop from "../images/custom_atolye_ekip.jpg";

export default function WhyUs(){
return(
    <section className="whyus">

        <div className="whyus-image">
    <img src={workshop} alt="" />
        </div>

         <div className="whyus-content">

        <span>NEDEN BİZ</span>

        <h2>Neden Neva Mermer?</h2>

        <p>
         Neva Mermer olarak, doğal taşın güzelliğini ve dayanıklılığını yaşam alanlarınıza taşıyoruz. Uzman iç mekân tasarımcımız ile çalışarak sadece taş uygulaması değil, bütünsel bir dekorasyon deneyimi sunuyoruz. Her projede malzeme seçiminden montaja kadar tüm süreci titizlikle yönetiyoruz.
        </p>

        <div className="stats">

          <div className="stat-box">
            <h3>15+</h3>
            <p>Yıllık Deneyim</p>
          </div>

          <div className="stat-box">
            <h3>500+</h3>
            <p>Tamamlanan Proje</p>
          </div>

          <div className="stat-box">
            <h3>300+</h3>
            <p>Mutlu Müşteri</p>
          </div>

          <div className="stat-box">
            <h3>10+</h3>
            <p>Hizmet Bölgesi</p>
          </div>

        </div>

      </div>

    </section>
)
}